<template>
  <div>
    <b-modal
      id="createAssessment-modal"
      class="modal_body-lg"
      centered
      title="Create Assessment"
      scrollable
      no-close-on-backdrop
      @close="cancel"
      size="xl"
      hide-footer
    >
      <template #modal-title>
        <div class="">
          <div>Create Assessment</div>
        </div>
      </template>
      <div class="modal_body-lg">
        <div v-if="loading" class="d-flex justify-content-center">
          <b-icon icon="three-dots" animation="cylon" font-scale="4"></b-icon>
        </div>
        <b-form ref="form" class="form-section" @submit="handleSubmit">
          <div class="">
            <label class="p-2 text-secondary mb-0">Title</label>
            <div class="p-2">
              <b-form-input
                v-model="formDetails.Title"
                placeholder="Enter title for problem"
                required
              ></b-form-input>
            </div>
          </div>
          <div class="">
            <label class="p-2 text-secondary mb-0">Publish Type</label>
            <b-form-group class="p-2">
              <b-button-group toggle class="d-flex">
                <b-button
                  v-for="(option, index) in publishOptions"
                  :key="index"
                  :variant="
                    formDetails.Publish_Type === option.value
                      ? 'primary'
                      : 'secondary'
                  "
                  @click="formDetails.Publish_Type = option.value"
                  class="d-flex align-items-center"
                  :active="formDetails.Publish_Type === option.value"
                >
                  <b-icon :icon="option.icon" class="mr-2"></b-icon>
                  {{ option.text }}
                  <b-icon
                    icon="info-circle"
                    class="ml-2 small-info-icon"
                    :title="option.info"
                  ></b-icon>
                </b-button>
              </b-button-group>
            </b-form-group>
          </div>
          <div class="">
            <label class="p-2 text-secondary mb-0">Description</label>
            <div class="p-2">
              <b-form-textarea
                v-model="formDetails.Description"
                placeholder="Enter description for problem"
                rows="3"
                required
              ></b-form-textarea>
            </div>
          </div>
          <div class="">
            <label class="p-2 text-secondary mb-0">Difficulty Level</label>
            <b-form-group class="p-2">
              <b-button-group toggle class="d-flex">
                <b-button
                  v-for="(option, index) in difficultyOptions"
                  :key="index"
                  :variant="
                    formDetails.Difficulty === option.value
                      ? 'primary'
                      : 'secondary'
                  "
                  @click="formDetails.Difficulty = option.value"
                  class="d-flex align-items-center"
                  :active="formDetails.Difficulty === option.value"
                >
                  <b-icon :icon="option.icon" class="mr-2"></b-icon>
                  {{ option.text }}
                  <b-icon
                    v-if="option.info"
                    icon="info-circle"
                    class="ml-2 small-info-icon"
                    :title="option.info"
                  ></b-icon>
                </b-button>
              </b-button-group>
            </b-form-group>
          </div>
          <div class="">
            <label class="p-2 text-secondary mb-0">Tags</label>
            <div class="p-2">
              <tags-input
                class="tags-input form-control"
                v-model="tabVal"
                :tags="formDetails.Tags"
                placeholder="Search tags (or) Press space to view all tags"
                :add-only-from-autocomplete="true"
                :autocomplete-items="allTags"
                @tags-changed="handleTagsChanged"
              ></tags-input>
            </div>
          </div>

          <div class="d-flex justify-content-end border-top pt-3">
            <button class="submitButton finishButton" type="submit">
              Create Assessment
            </button>
          </div>
        </b-form>
      </div>
    </b-modal>
    <b-modal
      id="create-error-modal"
      ref="create-error-modal"
      size="sm"
      buttonSize="sm"
      headerClass="p-2 border-bottom-0"
      footerClass="p-2 border-top-0"
      hide-header-close
      ok-only
      centered
      title="Oops."
    >
      <p class="my-4">{{ errMsg }}. Please try again</p>
    </b-modal>
  </div>
</template>

<script>
// import { createCodeProblem } from "../../api/index";
import TagsInput from "@johmun/vue-tags-input";
import { assessmentTags } from "../../constants/assessmentTags";

// import { codeDatatypes } from "../../constants/codeDatatypes";

export default {
  name: "createAssessmentModal",
  components: { TagsInput },
  data() {
    return this.initialState();
  },
  computed: {

  },
  watch: {
    // "formDetails.inputData": "updateTestCases",
    // "formDetails.expectedOutput_DataType": "updateTestCases",
  },

  methods: {
    initialState() {
      return {
        loading: false,
        submitLoading: false,
        errMsg: "",
        formDetails: {
          Title: "",
          Created_By: "",
          Description: "",
          Publish_Type: "public",
          Difficulty: "Medium",
          Tags: []
        },
        tabVal: "",
        allTags: assessmentTags || [],
        difficultyOptions: [
          { value: "Easy", text: "Easy", icon: "star", info: "" },
          { value: "Medium", text: "Medium", icon: "gear", info: "" },
          {
            value: "Hard",
            text: "Hard",
            icon: "exclamation-triangle",
            info: "",
          },
        ],
        publishOptions: [
          {
            value: "public",
            text: "Public",
            icon: "globe",
            info: "Visible to everyone.",
          },
          {
            value: "org",
            text: "My Org",
            icon: "people",
            info: "Visible to your organization.",
          },
          {
            value: "private",
            text: "Private",
            icon: "lock",
            info: "Visible only to you.",
          },
        ],
      };
    },
    handleTagsChanged(tags) {
      this.formDetails.Tags = tags.map((e) => {
        return { text: e.text };
      });
      this.tabVal = "";
    },

    cancel() {
      Object.assign(this.$data, this.initialState());
      this.$bvModal.hide("createAssessment-modal");
    },
    handleSubmit(event) {
      event.preventDefault();
      this.submitLoading = true;

      const tags = this.formDetails.Tags.map((e) => {
        return e.text;
      });

      let payload = {
        Title: this.formDetails.Title,
        Description: this.formDetails.Description,
        Tags: JSON.stringify(tags),
        Difficulty: this.formDetails.Difficulty,
        Publish_Type: this.formDetails.Publish_Type,
      };
      this.$store.commit("setTeamCreateAssessDetail",payload);
      this.$router.push("/interviews/createAssessment");
    },
  },
};
</script>

<style>
.w-half {
  width: 50% !important;
}
.small-info-icon {
  font-size: 0.75rem !important; /* Adjust the size of the icon */
  cursor: pointer;
  margin-left: auto !important;
}
.tags-input {
  max-width: 100% !important;
}
.ti-input {
  border: none !important;
  padding: 0px !important;
}
.ti-autocomplete {
  max-height: 200px !important;
  overflow: auto !important;
  width: 99% !important;
}
.ti-tag {
  background: var(--primary-color) !important;
  padding: 1px 8px !important;
  margin: 0px !important;
  margin-left: 4px !important;
  margin-right: 4px !important;
}
.ti-new-tag-input,
.ti-tag-center {
  font-size: 1rem !important;
  font-weight: 400 !important;
  line-height: 1.5 !important;
}
.ti-new-tag-input-wrapper {
  padding: 0px !important;
  padding-left: 4px !important;
  margin: 0px !important;
}
.inputsData-container {
  display: flex;
  flex-wrap: wrap; /* Allows items to wrap to the next row */
  gap: 16px;
}
.inputsData-item {
  flex: 0 1 calc(50% - 16px); /* Each item takes up approximately 50% of the container's width minus the gap */
  box-sizing: border-box;
}
.tm-testcase-div {
  background-color: var(--light-gray);
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
.c1-dropdown {
  max-height: 200px;
  overflow-y: scroll;
}
</style>
